export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7346.669d2a36.jpg";